import { render, staticRenderFns } from "./volume-details.vue?vue&type=template&id=35a4f843"
import script from "./volume-details.vue?vue&type=script&lang=js"
export * from "./volume-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports